import { render, staticRenderFns } from "./ProductDetails21.vue?vue&type=template&id=46ae3094&scoped=true"
import script from "./ProductDetails21.vue?vue&type=script&lang=js"
export * from "./ProductDetails21.vue?vue&type=script&lang=js"
import style0 from "./ProductDetails21.vue?vue&type=style&index=0&id=46ae3094&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ae3094",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F03-organisms%2Fproduct-details-21%2FProductDetails21.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports